export class LibraryFont {
  source: string;
  name: string;

  constructor(font: LibraryFont = null) {
    if (font == null) {
      this.source = "";
      this.name = "";
    } else {
      this.source = font.source;
      this.name = font.name;
    }
  }
}
